import { Badge } from "reactstrap";
import i18n from "../../../i18n";

/*
* Lead pipeline
*/
const LEAD_STATUS_COLORS = {
  new: 'primary',
  contacted: 'info',
  qualified: 'success',
  quotation_sent: 'warning',
  negotiation: 'secondary',
  won: 'success',
  lost: 'danger'
};

/** Stages a lead moves through, in order. "lost" sits outside the pipeline. */
export const LEAD_STAGES = ['new', 'contacted', 'qualified', 'quotation_sent', 'negotiation', 'won'];

export function leadStatusLabel(status) {
  return status ? i18n.t('crm.' + status) : '';
}

export function printLeadStatus(status) {
  const color = LEAD_STATUS_COLORS[status];
  if (!color) return '';

  return <Badge color={color}>{leadStatusLabel(status)}</Badge>;
}

/*
* Calls
*/
const CALL_STATUS_META = {
  scheduled: { color: 'info', key: 'crm.scheduled' },
  completed: { color: 'success', key: 'common.completed' },
  cancelled: { color: 'danger', key: 'common.canceled' }
};

export function callStatusLabel(status) {
  const meta = CALL_STATUS_META[status];
  return meta ? i18n.t(meta.key) : status || null;
}

export function printCallStatus(status) {
  const meta = CALL_STATUS_META[status];
  if (!meta) return '';

  return <Badge color={meta.color}>{i18n.t(meta.key)}</Badge>;
}

const CALL_TYPE_META = {
  inbound: { color: 'info', key: 'crm.inbound' },
  outbound: { color: 'primary', key: 'crm.outbound' },
  missed: { color: 'danger', key: 'common.missed' }
};

export function callTypeLabel(type) {
  const meta = CALL_TYPE_META[type];
  return meta ? i18n.t(meta.key) : type || null;
}

export function printCallType(type) {
  const meta = CALL_TYPE_META[type];
  if (!meta) return '';

  return <Badge color={meta.color}>{i18n.t(meta.key)}</Badge>;
}

/*
* Tasks — colors match the kanban columns on the tasks board
*/
export const TASK_STAGES = ['not_started', 'in_progress', 'completed'];

export const TASK_STATUSES = ['not_started', 'in_progress', 'completed', 'deferred', 'cancelled'];

const TASK_STATUS_META = {
  not_started: { color: 'secondary', key: 'common.notStarted' },
  in_progress: { color: 'info', key: 'common.inProgress' },
  completed: { color: 'success', key: 'common.completed' },
  deferred: { color: 'warning', key: 'common.deferred' },
  cancelled: { color: 'danger', key: 'common.canceled' }
};

export function taskStatusLabel(status) {
  const meta = TASK_STATUS_META[status];
  return meta ? i18n.t(meta.key) : status || '';
}

export function printTaskStatus(status) {
  const meta = TASK_STATUS_META[status];
  if (!meta) return '';

  return <Badge color={meta.color}>{i18n.t(meta.key)}</Badge>;
}

const PRIORITY_META = {
  high: { color: 'danger', key: 'common.high' },
  normal: { color: 'secondary', key: 'common.normal' },
  low: { color: 'info', key: 'common.low' }
};

export function priorityLabel(priority) {
  const meta = PRIORITY_META[priority];
  return meta ? i18n.t(meta.key) : priority || null;
}

export function printPriority(priority) {
  const meta = PRIORITY_META[priority];
  if (!meta) return '';

  return <Badge color={meta.color}>{i18n.t(meta.key)}</Badge>;
}

/*
* Shared formatting
*/

/** "45 min" — call durations and meeting lengths are stored in minutes. */
export function formatMinutes(minutes) {
  if (minutes === null || minutes === undefined || minutes === '') return null;

  return `${minutes} ${i18n.t('common.minutesShort')}`;
}

/** Minutes between two timestamps, null when either end is missing. */
export function minutesBetween(from, to) {
  if (!from || !to) return null;

  const diff = (new Date(to) - new Date(from)) / 60000;
  return Number.isFinite(diff) && diff >= 0 ? Math.round(diff) : null;
}

/** A person's display name, null when the relation was not loaded. */
export function personName(person) {
  return [person?.firstname, person?.lastname].filter(Boolean).join(' ') || null;
}
